import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function CTWhyChoose() {
  return <section className="bg-black py-[60px] lg:py-[100px]" data-id="element-826">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-827">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20" data-id="element-828">
          <AnimateOnScroll className="w-full lg:w-[40%]" delay={200} data-id="element-829">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-830">
              <img src="https://cdn.magicpatterns.com/uploads/7zG3MnygFBqmv2pT7xpwWY/AdobeStock_257206406-5.webp" alt="Be CLINICAL Treatment Session" className="w-full h-full object-cover" data-id="element-831" />
            </div>
          </AnimateOnScroll>

          <AnimateOnScroll className="w-full lg:w-[60%] text-center lg:text-left flex flex-col items-center lg:items-start" data-id="element-832">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-833">
              WHY CHOOSE BE CLINICAL FOR COOLTONE?
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-10" data-id="element-834"></div>

            <div className="space-y-6 text-[#B0B0B0] text-[17px] leading-[1.8] font-body mb-10" data-id="element-835">
              <p data-id="element-836">
                When considering CoolTone treatment, choosing Be CLINICAL
                ensures a journey marked by expertise, innovation, and
                personalized care. Our commitment to excellence permeates every
                aspect of our practice, from the moment you walk through our
                doors to the completion of your transformative journey. At Be
                CLINICAL, we prioritize your unique goals and concerns, crafting
                tailored treatment plans that leverage the latest advancements
                in aesthetic technology, including CoolTone.
              </p>
              <p data-id="element-837">
                Our team of highly skilled professionals, renowned for their
                expertise in non-surgical body contouring, ensures that each
                CoolTone session is meticulously executed to deliver optimal
                results. With a focus on safety, efficacy, and patient
                satisfaction, Be CLINICAL stands as a beacon of quality in the
                realm of cosmetic enhancements.
              </p>
              <p data-id="element-838">
                Choose Be CLINICAL for CoolTone today and together we will
                embark on a path to redefine your physique with confidence and
                precision. Request your complimentary consultation today!
              </p>
            </div>

            <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-839">
              BOOK CONSULT
            </Button>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}